import styled from 'styled-components';

export const Main = styled.div`
   min-width: 150px;
   padding: 0;
`;

export const Styled = styled.div`
   .action {
      position: relative;
      padding-bottom: 10px;
      margin-bottom: 11px;

      &::after {
         content: '';
         position: absolute;
         left: 0;
         bottom: 0;
         width: 100%;
         height: 0.5px;
         background-color: rgb(220, 220, 220);
      }
   }

   .select {
      margin-bottom: 10px;

      h4 {
         width: 90px;
      }
   }

   .textInput {
      margin-bottom: 10px;

      h4 {
         width: 110px;
      }
   }

   .textarea {
      margin-top: 25px;

      > h4 {
         width: 90px;
      }

      > div {
         min-height: 100px;
         height: 100px;
      }
   }

   .previewSection {
      margin-top: 14px;
      border: 1px solid rgb(220, 220, 220);
      background: rgb(249, 250, 251);
      border-radius: 8px;
      overflow: hidden;
      width: 420px;

      h5 {
         margin: 0;
         padding: 8px 10px;
         border-bottom: 1px solid rgb(220, 220, 220);
         font-size: 13px;
         opacity: 0.85;
      }

      pre {
         margin: 0;
         padding: 10px;
         max-height: 100px;
         overflow: auto;
         font-size: 12px;
         line-height: 1.45;
         font-family: 'Courier New', monospace;
         white-space: pre-wrap;
      }
   }
`;
